import _regeneratorRuntime from "@babel/runtime/regenerator";

function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }

function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }

import axios from 'axios';
export function fetchStateList(_x, _x2, _x3, _x4) {
  return _fetchStateList.apply(this, arguments);
}

function _fetchStateList() {
  _fetchStateList = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(config, apiUrl, callback, handleError) {
    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            return _context.abrupt("return", axios.get(apiUrl + "/settings-api/states", config).then(function (res) {
              var states = [];
              res.data.map(function (state) {
                states.push({
                  abbr: state.StateAbbr__c,
                  name: state.State__c
                });
              });
              return states;
            }).then(callback)["catch"](handleError));

          case 1:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));
  return _fetchStateList.apply(this, arguments);
}